<template>
  <div>
    <p class='mb-5'>{{ 'recovery.new.description' | translate }}</p>
    <ReportOfSicknessCard
      class='mt-5 mb-4'
      :employee="this.employee"
      :reportOfSickness="reportOfSickness" />

    <RecoveryForm
      :isEditing="false"
      :reportOfSickness="reportOfSickness" />

    <div style='float: right' class='mt-4'>
      <Button primary class='mr-3' @click="this.handleCancelClick">
        {{ 'buttons.cancel' | translate }}
      </Button>

      <template v-if="isValid">
        <Button secondary @click="this.handleContinueClick">
          {{ 'buttons.next-step' | translate }}
        </Button>
      </template>

      <template v-if="!isValid">
        <v-tooltip top color='#fd4160'>
          <Button secondary disabled @click="this.handleContinueClick" slot='activator'>
            {{ 'buttons.next-step' | translate }}
          </Button>
          <span>Vul alle gegevens in</span>
        </v-tooltip>
      </template>
    </div>
  </div>
</template>

<script>
import NewRecoveryConstants from '@/views/constants/recovery-new';

import RecoveryForm from '@/views/components/recovery-new/RecoveryForm.vue';
import ReportOfSicknessCard from '@/views/components/reports-of-sickness/ReportOfSicknessCard.vue';

import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';

export default {
  name: 'NewRecoveryInputForm',

  components: {
    RecoveryForm,
    ReportOfSicknessCard,
    Button
  },
  props: {
    reportOfSickness: Object,
    employee: Object
  },
  computed: {
    isValid () {
      return this.$store.getters.newRecoveryRequiredFields.isValid();
    }
  },
  methods: {
    handleCancelClick () {
      this.$store.dispatch(NewRecoveryConstants.Actions.Cancel.DO);
    },
    handleContinueClick () {
      this.$store.dispatch(NewRecoveryConstants.Actions.Navigate.DO,
        NewRecoveryConstants.Views.NewRecoveryConfirmation);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';

.theme--light.v-divider {
  border-color: $gray-lighten-1;
}
</style>
